// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__24ZLw","title":"Images90_title__3rquV","images":"Images90_images__3QPfE"};